import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { ModalFooter } from 'react-bootstrap';
import Button from '../ui/Button';
import { downloadURL } from '../../utils/umoUtils';

const DynamicDownloadView = ({ data, userEmail, dispatch, hideDialog, intl }) => {
  const [dynamicEmail, setEmail] = useState(userEmail || '');
  const [emailError, setEmailError] = useState(false);

  const onDownload = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!dynamicEmail || !(/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(dynamicEmail))) {
      setEmailError('general.invalidEmail');
      return false;
    }
    downloadURL(data.url, data.name, dispatch, data.isDynamic, dynamicEmail);
    hideDialog();
    return true;
  };

  return (
    <form className="share-view__modal" onSubmit={onDownload} noValidate>
      <div className="workspace-dialog__form-header">
        {intl.formatMessage({ id: 'workspaceDownloadDialog.mainTitle' })}
      </div>
      <div key="dynamic_deriv_email" className="form-group">
        <h6 className="workspace-dialog__form-header-sub">
          {intl.formatMessage({ id: 'workspaceEmailDialog.toEmailPlaceholder' })}
        </h6>
        <label key="test">
          <input
            type="email"
            className="form-control"
            onChange={e => setEmail(e.target.value)}
            style={{ borderColor: emailError ? 'red' : '#ced4da', width: '350px' }}
            value={dynamicEmail}
            required
          />
        </label>
        {emailError ?
          <div className="invalid-feedback" style={{ display: 'block' }}>
            {intl.formatMessage({ id: emailError })}
          </div> : null
            }
      </div>
      <div className="form-group workspace-dialog__form-header-text">
        {intl.formatMessage({ id: 'workspaceDownloadDialog.emailDynamicDownload' })}
      </div>
      <ModalFooter>
        <Button type="submit" variant="primary">
          {intl.formatMessage({ id: 'workspaceDownloadDialog.buttonDownload' })}
        </Button>
        <Button onClick={hideDialog}>
          {intl.formatMessage({ id: 'categoryMoveDialog.cancelButton' })}
        </Button>
      </ModalFooter>
    </form>
  );
};

DynamicDownloadView.propTypes = {
  hideDialog: PropTypes.func,
  dispatch: PropTypes.func,
  data: PropTypes.instanceOf(Object),
  userEmail: PropTypes.string,
};

export default injectIntl(DynamicDownloadView);




// WEBPACK FOOTER //
// ./src/js/components/UMODownloadView/DynamicDownloadView.jsx